import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from "react";
import { useTheme } from "../../../theme/utils/useTheme";
import { TooltipBodyStyled } from "../styled/TooltipBodyStyled";

// Nothing here on purpose, just keeping the namespace open.
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export const TooltipBody = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    ...rest
  } = _ref;
  const {
    key
  } = useTheme();
  const themeMode = key;
  return /*#__PURE__*/React.createElement(TooltipBodyStyled, _extends({}, rest, {
    themeMode: themeMode,
    ref: ref
  }), children);
});
TooltipBody.displayName = "TooltipBody";
//# sourceMappingURL=TooltipBody.js.map